const APPEND_TASK_SUMMARY_EMAILS = new Set([
	"arturo@hourglass.law",
	"thibbard@gouldratner.com",
]);

/** Pilot visibility is based on the signed-in viewer, not a delegated timekeeper. */
export function canAppendTaskSummary(
	email: string | null | undefined,
): boolean {
	return APPEND_TASK_SUMMARY_EMAILS.has(email?.trim().toLowerCase() ?? "");
}

/** Null means there is nothing new to append. Preserve existing narrative text. */
export function appendTaskSummary(
	narrative: string,
	summary: string | null | undefined,
): string | null {
	const text = summary?.trim();
	if (!text || narrative.includes(text)) return null;
	const separator = narrative && !/\s$/.test(narrative) ? " " : "";
	return `${narrative}${separator}${text}`;
}

export interface AppendTaskSummaryAction {
	disabledIds: ReadonlySet<string>;
	onAppend: (entryId: string, sourceId: string) => void;
}
